import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set page title and meta tags for link previews
document.title = 'QTap WC Smart T-Shirt';
const metaTags = [{
  property: 'og:title',
  content: 'QTap WC Smart T-Shirt'
}, {
  property: 'og:description',
  content: "The world's first NFC-enabled smart t-shirt built for the FIFA World Cup 2026. Tap it with any phone to instantly share your team profile, stats, and exclusive content."
}, {
  property: 'og:type',
  content: 'website'
}, {
  name: 'description',
  content: "The world's first NFC-enabled smart t-shirt built for the FIFA World Cup 2026. Tap it with any phone to instantly share your team profile, stats, and exclusive content."
}];
metaTags.forEach(({
  property,
  name,
  content
}) => {
  const selector = property ? `meta[property="${property}"]` : `meta[name="${name}"]`;
  let tag = document.querySelector(selector) as HTMLMetaElement | null;
  if (!tag) {
    tag = document.createElement('meta');
    if (property) tag.setAttribute('property', property);
    if (name) tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
});
render(<App data-id="element-667" />, document.getElementById('root'));